import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@material-ui/core';

import RealEstateAgentPresenter from 'presenters/RealEstateAgentPresenter';

import Step from './components/Step';

import useStyles from './useStyles';

const Guide = props => {
  const { onStart, realEstateAgent } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const agentFirstName = RealEstateAgentPresenter.firstName(realEstateAgent);

  return (
    <div className={classes.container}>
      <Step
        stepNumber="1"
        title={t('components.ReferralRealEstateAgent.Guide.firstStepTitle')}
        description={t('components.ReferralRealEstateAgent.Guide.firstStepDescription')}
      />
      <div className={classes.divider} />
      <Step
        stepNumber="2"
        title={t('components.ReferralRealEstateAgent.Guide.secondStepTitle')}
        description={t('components.ReferralRealEstateAgent.Guide.secondStepDescription', { agentFirstName })}
      />
      <div className={classes.divider} />
      <Step
        stepNumber="3"
        title={t('components.ReferralRealEstateAgent.Guide.thirdStepTitle')}
        description={t('components.ReferralRealEstateAgent.Guide.thirdStepDescription')}
      />
      <Typography className={classes.discription} variant="body1">
        {t('components.ReferralRealEstateAgent.Guide.description', { agentFirstName })}
      </Typography>
      <Button onClick={onStart} className={classes.button}>
        {t('components.ReferralRealEstateAgent.Guide.button')}
      </Button>
    </div>
  );
};

Guide.propTypes = {
  onStart: PropTypes.func.isRequired,
};

export default Guide;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/Guide/Guide.js